export const REPORT_TYPES = {
  CALLS_REPORT: 0,
  TOTAL_PERFORMANCE: 1,
  PERFORMANCE_BY_PERIOD: 2,
  SYSTEM_INBOUND: 3,
  AGENT_LEAVING_DETAIL: 4,
  AGENT_LEAVING_SUMMARY: 5,
  AGENT_LOGIN_DETAIL: 6,
  AGENT_LOGIN_SUMMARY: 7,
  AGENT_STATUS_DETAIL: 8,
  AGENT_STATUS_SUMMARY: 9,
  KPI_REPORT: 10,
  CSAT_REPORT: 11,
  REPEATED_CALLS_REPORT: 12,
  CALL_REASONS_REPORT: 13,
  IVR_REPORT: 14,
  CSAT_TABLE_REPORT: 15,
  VOICE_AGENT_CDR: 17,
  AI_CHAT_TRANSCRIPT: 18
};

export const REPORT_CONFIG = {
  [REPORT_TYPES.CALLS_REPORT]: {
    name: 'reports.filters.calls_report',
    hasCallType: true,
    hasAgents: true,
    hasAgentStatus: false,
    hasHungparty: true,
    hasNumber: true,
    hasDuration: true,
    hasSkill: true,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: true,
    defaultLimit: 10,
    availableLimits: [10, 25, 50, 100],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 12
  },
  [REPORT_TYPES.TOTAL_PERFORMANCE]: {
    name: 'reports.filters.total_performance',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 8,
    loadingColumns: 8
  },
  [REPORT_TYPES.PERFORMANCE_BY_PERIOD]: {
    name: 'reports.filters.performance_by_period',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: true,
    hasPeriod: true, // Commented out - using half hours only
    hasOmni: false,
    isNotExport: false,
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [],
    useSingleDayDatePicker: false, // Special single-day date picker for this report
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 6,
    loadingColumns: 6
  },
  [REPORT_TYPES.SYSTEM_INBOUND]: {
    name: 'reports.filters.system_inbound',
    hasCallType: true,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: true,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: true,
    defaultLimit: 10,
    availableLimits: [10, 25, 50, 100],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 5
  },
  [REPORT_TYPES.AGENT_LEAVING_DETAIL]: {
    name: 'reports.filters.agent_leaving_detail',
    hasCallType: false,
    hasAgents: true,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: true,
    defaultLimit: 10,
    availableLimits: [10, 25, 50, 100],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 7
  },
  [REPORT_TYPES.AGENT_LEAVING_SUMMARY]: {
    name: 'reports.filters.agent_leaving_summary',
    hasCallType: false,
    hasAgents: true,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: true,
    defaultLimit: 10,
    availableLimits: [10, 25, 50, 100],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 5
  },
  [REPORT_TYPES.AGENT_LOGIN_DETAIL]: {
    name: 'reports.filters.agent_login_detail',
    hasCallType: false,
    hasAgents: true,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: true,
    defaultLimit: 10,
    availableLimits: [10, 25, 50, 100],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 5
  },
  [REPORT_TYPES.AGENT_LOGIN_SUMMARY]: {
    name: 'reports.filters.agent_login_summary',
    hasCallType: false,
    hasAgents: true,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: true,
    defaultLimit: 10,
    availableLimits: [10, 25, 50, 100],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 5
  },
  [REPORT_TYPES.AGENT_STATUS_DETAIL]: {
    name: 'reports.filters.agent_status_detail',
    hasCallType: false,
    hasAgents: true,
    hasAgentStatus: true,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: true,
    defaultLimit: 10,
    availableLimits: [10, 25, 50, 100],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 5
  },
  [REPORT_TYPES.AGENT_STATUS_SUMMARY]: {
    name: 'reports.filters.agent_status_summary',
    hasCallType: false,
    hasAgents: true,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: true,
    defaultLimit: 10,
    availableLimits: [10, 25, 50, 100],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 6
  },
  [REPORT_TYPES.KPI_REPORT]: {
    name: 'reports.filters.kpi_report',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 12
  },
  [REPORT_TYPES.CSAT_REPORT]: {
    name: 'reports.filters.csat_report',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: true,
    useSingleDayDatePicker: false,
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [], 
    loadingType: 'skeleton',
    loadingVariant: 'chart',
    loadingRows: 3,
    loadingColumns: 4
  },
  [REPORT_TYPES.REPEATED_CALLS_REPORT]: {
    name: 'reports.filters.repeated_calls_report',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 2
  },
  [REPORT_TYPES.CALL_REASONS_REPORT]: {
    name: 'reports.filters.call_reasons_report',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 3,
    loadingColumns: 3
  },
  [REPORT_TYPES.IVR_REPORT]: {
    name: 'reports.filters.ivr_report',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    hasReportVariant: false,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 10
  },
  [REPORT_TYPES.CSAT_TABLE_REPORT]: {
    name: 'reports.filters.csat_table_report',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    hasReportVariant: true,
    isNotExport: false,
    useSingleDayDatePicker: false,
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 10
  },
  [REPORT_TYPES.VOICE_AGENT_CDR]: {
    name: 'reports.filters.voice_agent_cdr',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: true,
    useSingleDayDatePicker: false,
    // The list endpoint does not paginate server-side; render all rows in range.
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 8
  },
  [REPORT_TYPES.AI_CHAT_TRANSCRIPT]: {
    name: 'reports.filters.ai_chat_transcript',
    hasCallType: false,
    hasAgents: false,
    hasAgentStatus: false,
    hasHungparty: false,
    hasNumber: false,
    hasDuration: false,
    hasSkill: false,
    hasPeriod: false,
    hasOmni: false,
    isNotExport: true,
    useSingleDayDatePicker: false,
    // The list endpoint does not paginate server-side; render all rows in range.
    supportsPagination: false,
    defaultLimit: 0,
    availableLimits: [],
    loadingType: 'skeleton',
    loadingVariant: 'table',
    loadingRows: 10,
    loadingColumns: 7
  },
};

export const DEFAULT_FILTERS = {
  from: null,
  to: null,
  callType: 0,
  agent: 0,
  hungparty: 0,
  number: '',
  duration: '',
  skill: 0,
  period: 2,
  agentStatus: 'All',
  ratingType: 1,
  reportVariant: 'per-agent',
  export: false
};

export const PAGINATION_CONFIG = {
  defaultLimit: 10,
  availableLimits: [10, 25, 50, 100],
  maxVisiblePages: 7
}; 